// Returns true if the JWT is missing, malformed, or past its "exp" time
export function isJwtExpired(token) {
    if (!token) return true;
    try {
        let payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        payload += '='.repeat((4 - payload.length % 4) % 4);
        const claims = JSON.parse(atob(payload));
        if (!claims.exp) return false;
        return Date.now() >= claims.exp * 1000;
    } catch (e) {
        return true;
    }
}

export function clearStoredAuth() {
    localStorage.removeItem('jwt');
    localStorage.removeItem('username');
    localStorage.removeItem('id');
    localStorage.removeItem('roles');
}